module.exports = __webpack_public_path__ + "static/media/it-services.0bea735f.svg";